import React from 'react';

const HighlightsIcon = ({ color = "#1E1E1E", opacity = 0.8 }) => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.75 9.75C18.75 14.7206 14.7206 18.75 9.75 18.75C4.77944 18.75 0.75 14.7206 0.75 9.75C0.75 4.77944 4.77944 0.75 9.75 0.75C14.7206 0.75 18.75 4.77944 18.75 9.75Z" stroke={color} strokeOpacity={opacity} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M13.6599 9.42219C13.9171 9.56507 13.9171 9.93493 13.6599 10.0778L8.05712 13.1905C7.80717 13.3294 7.5 13.1486 7.5 12.8627V6.63732C7.5 6.35139 7.80717 6.17065 8.05712 6.30951L13.6599 9.42219Z" stroke={color} strokeOpacity={opacity} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
};

export default HighlightsIcon;
